<template>
  <svg width="67.89" height="39.17" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67.89 39.17"><path d="M55.61 39.17H11.52a11.52 11.52 0 1 1 0-23h.61a11.35 11.35 0 0 1 15.45-8.59A14.79 14.79 0 0 1 40.31 0a14.52 14.52 0 0 1 14.47 14.47v.3h.76a12.2 12.2 0 1 1 .08 24.4" fill-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'CloudRight'
}
</script>
